import IListResponse from '../../utils/list-response';
import jhsfBookingsApi from '../apis/jhsfBookingsApi';

export interface IBookingExternalPaymentReport {
  activityName: string;
  authorizedAt?: string;
  bookedDate: string;
  bookedEndTime: string;
  bookedStartTime: string;
  bookingId: string;
  customerName: string;
  itemBilledAmount: number;
  itemId: string;
  itemName: string;
  status: string;
  nsu: string;
  authorizationCode: string;
  brand: string;
  paymentType: string;
  scheduleExperience: number;
  sellerName: string;
  waveSide?: 'COMBO' | 'LEFT' | 'RIGHT';
  costCenter: string;
  productCode: string;
  productType: string;
  productNature: string;
  invoiceType: string;
}

export type IBookingExternalPaymentReportsList =
  IListResponse<IBookingExternalPaymentReport>;

interface IListBookingExternalPaymentReportsProps {
  authorizationDateEnd: Date;
  authorizationDateInit: Date;
  limit?: number;
  order?: 'ASC' | 'DESC';
  page?: number;
  sort?: 'createdAt';
}

export const listBookingExternalPaymentReportsService = async ({
  authorizationDateEnd,
  authorizationDateInit,
  limit,
  order,
  page,
  sort,
}: IListBookingExternalPaymentReportsProps): Promise<IBookingExternalPaymentReportsList> => {
  const { data } =
    await jhsfBookingsApi.get<IBookingExternalPaymentReportsList>(
      '/bookings/external-payments/reports',
      {
        params: {
          authorizationDateEnd,
          authorizationDateInit,
          limit,
          order,
          page,
          sort,
        },
      },
    );

  return data;
};
